import queryString from "query-string";
import { QueryParamOptions } from "use-query-params";

export class QsUtils {
  private static searchStringToObject(v: string) {
    return queryString.parse(v, { arrayFormat: "comma" });
  }
  private static objectToSearchString(v: Record<string, any>) {
    return queryString.stringify(v, { arrayFormat: "comma", encode: false });
  }
  static getQueryParamFormatter(): QueryParamOptions {
    return {
      searchStringToObject: this.searchStringToObject,
      objectToSearchString: this.objectToSearchString,
    };
  }
}
